import {scrollMove} from '../lib/funcLibrary';

const PinpointCarousel = (props) => {
  const {movie_img, extraCSS} = props;

  const repeat = movie_img ? movie_img.map((el, idx) => 
    <div onClick={() => scrollMove(idx)} id={`pin${idx}`} key={el} className="PinpointCarousel_pinpoint"></div>
  ): "";

  return (
    <div className={`pinpointPinpointCarouselWrapper ${extraCSS}`}>
      {repeat}
    </div>
  )
}

export default PinpointCarousel;